let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cP7zi")).then(() => parcelRequire('lfHjR'));